export default __webpack_public_path__ + "static/media/1.9e5bcb0a.jpg";